import { UploadExcelThemeModeConfig } from './types';

const dark: UploadExcelThemeModeConfig = {
  uploadExcel: {
    uploadTempBGColor: '#DADBDC',
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default dark;
